import { gql } from "@apollo/client";

export const GET_SERVICES = gql`
  query GetServices {
    services {
      serviceId
      name
    }
  }
`;

export const CREATE_SERVICE = gql`
  mutation CreateService($name: String!) {
    createService(name: $name) {
      serviceId
      name
    }
  }
`;
